export default "__VITE_ASSET__BBUwQNZA__"